import React from 'react'
import { useNavigate } from 'react-router-dom'

export const useMenuForNotAuthenticated = (closeDrawer: () => void) => {
  const navigate = useNavigate()


  const onSearchClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    navigate("/search")
  }

  const onNonprofitCatalogClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    navigate("/nonprofit-catalog")
  }

  return {
    onSearchClickHandler,
    closeDrawer,
    onNonprofitCatalogClickHandler
  }
}
